module.exports = __webpack_public_path__ + "media/images/element/medal-8c7094c7d82f805e71aafcbe4033de24.svg";